var container
var pckry 
var $mq 
function initGrid() {
	setTimeout(function(){
		pckry = $('.js-bubbles').packery({
		    // Options
		    itemSelector: '.item',
		    gutter: 3,
		    stamp: '.stamp',
		    horizontal: false,
		    originLeft: true,
		    originTop: false,
		    resize: false

		});
	},150)
}

function initMarquee() {
	$mq = $('.js-marquee').marquee({
		direction: 'left',
    	duplicated: true,
    	delayBeforeStart: 0,
    	startVisible: true,	
    	speed: 20,
    	gap: 0,
	});
}

function resizeImages() {
	$('.js-bubbles img').each(function(){
		$(this).css("width", "auto").css("height", "auto"); // Remove existing CSS
	    $(this).removeAttr("width").removeAttr("height"); // Remove HTML attributes
	    var width = $(this).width()
	    var height = $(this).height()

	    if ($(window).innerWidth() > 1024) {
	    	return;
	    }

	    if ($(window).innerWidth() < 1024 && $(window).innerWidth() > 767) {
			$(this).css("width", width * .8);
	        $(this).css("height", height * .8);  
	    }

	    if ($(window).innerWidth() < 767) {
			$(this).css("width", width * .4);
	        $(this).css("height", height * .4);  
	    }
	});
}

$(window).on('load', function(){
	resizeImages()
	initMarquee()
	initGrid()
}).on('resize', function(){
	resizeImages()
	if( pckry.data('packery') ) { pckry.packery('destroy'); }
	initGrid()
})